import axios from "axios";
import axiosFileupload from "axios-fileupload";
import { INSTANCE_URL } from "Constants";

import { getRequest, postRequest, deleteRequest } from "NetworkCall";
import { showLoading, hideLoading } from "react-redux-loading-bar";

export const SPEAKER_FILE_LIST = "SPEAKER_FILE_LIST";

export function uploadSpekarFile(session, speakerid, file, callback) {
  return (dispatch) => {
    dispatch(showLoading());
    axiosFileupload(`${INSTANCE_URL}/upload.php?filename=speakerfile`, file)
      .then(({ data }) => {
        var resource;
        var url = `${INSTANCE_URL}/api/v2/eventify/_table/speakerfiles`;
        //var response;

        var resource = {
          speakerid,
          filepath: data,
          filetype: file.type,
          filename: file.name,
          eventid: session.eventid,
        };
        postRequest(
          url,
          { resource },
          session,
          dispatch,
          (data) => {
            dispatch(hideLoading());
            callback({ success: 1 });
            dispatch(fetchSpeakerFileList(session, speakerid));
          },
          (error) => {
            callback({ success: 0, message: error });
          }
        );
      })
      .catch((error) => {
        callback({ success: 0, message: error });
      });
  };
}

export function fetchSpeakerFileList(session, speakerid) {
  return (dispatch) => {
    var url = `${INSTANCE_URL}/api/v2/eventify/_table/speakerfiles?filter=speakerid=${speakerid}`;
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: SPEAKER_FILE_LIST, payload: data });
      },
      (error) => {
        // nothing to do
      }
    );
  };
}

export function deleteSpeakerFile(session, speakerfileid, speakerid, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/speakerfiles/${speakerfileid}`;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        callback({ error: 0 });
        dispatch(fetchSpeakerFileList(session, speakerid));
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
}
